// Local'de bulut backend ile test: REACT_APP_API_URL=https://valonix.io/api npm start
export const build_type = process.env.REACT_APP_BUILD_TYPE || "prod";

export let API_URL;
export let base_name;

if (process.env.REACT_APP_API_URL) {
  API_URL = process.env.REACT_APP_API_URL;
  base_name = process.env.REACT_APP_BASE_NAME || "";
} else if (build_type === "prod") {
  API_URL = "/api";
  base_name = "";
} else if (build_type === "test") {
  API_URL = "";
  base_name = "";
} else {
  API_URL = "http://localhost:8000";
  base_name = "iot";
}
